import { createStateHook, createDispatchHook } from '.';
/**
 * Create a hook and return a pair of state and dispatch
 */
export var createContextHook = function (stateContext, dispatchContext) {
    return function () { return [
        createStateHook(stateContext)(),
        createDispatchHook(dispatchContext)()
    ]; };
};
//# sourceMappingURL=createContextHook.js.map